import { DTO__generation } from '../DTO__generation';

export class DTO_TREE__generations_sliding_window {
  //ids of root's children
  generations_ids_path: string[];

  columns: DTO__generation[][];

  /*
   * METHODS
   */

  constructor() {
    this.columns = [];

    this.generations_ids_path = [];
  }

  is_part_of_path(generation_id: string) {
    return this.generations_ids_path.includes(generation_id);
  }
}
